import { combineReducers } from 'redux';
import user, * as fromUser from './userReducer';
import login, * as fromLogin from './loginReducer';
import client, * as fromClient from './clientReducer';
import location, * as fromLocation from './locationReducer';
import dashboard, * as fromDashboard from './dashboardReducer';

export default combineReducers({
  user,
  login,
  client,
  location,
  dashboard,
});

export const getUser = (state) => fromUser.getUser(state.user);
export const getLogin = (state) => fromLogin.getLogin(state.login);
export const getClient = (state) => fromClient.getClient(state.client);
export const getLocation = (state) => fromLocation.getLocation(state.location);
export const getDashboard = (state) => fromDashboard.getDashboard(state.dashboard);
